function truncateText(text, limit = 100) {
  if (typeof text !== 'string') return false
  const string = String(text)
  if (string.length <= limit) return string
  return `${string.substring(0, limit).trim()}...`
}

export default truncateText
